import { render, staticRenderFns } from "./QuickItemListSideMenu.vue?vue&type=template&id=571764bb&scoped=true"
import script from "./QuickItemListSideMenu.vue?vue&type=script&lang=js"
export * from "./QuickItemListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./QuickItemListSideMenu.vue?vue&type=style&index=0&id=571764bb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571764bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('571764bb')) {
      api.createRecord('571764bb', component.options)
    } else {
      api.reload('571764bb', component.options)
    }
    module.hot.accept("./QuickItemListSideMenu.vue?vue&type=template&id=571764bb&scoped=true", function () {
      api.rerender('571764bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quickitem/QuickItemListSideMenu.vue"
export default component.exports